import { TOGGLE_DEAL_MODE } from '../actionTypes/dealModeActionTypes';
import { DealMode } from '../types/dealModeEnum';
import { CALC_ENDPOINTS } from '../constants';
import { updateCurrentCalculationEndpoint, setProgramFallbackOverrides } from './offerRedux';
import * as offerReduxSelectors from '../selectors/offerRedux';

export const changeDealMode = (currentMode: DealMode) => ({
    type: TOGGLE_DEAL_MODE,
    payload: currentMode
});

export const toggleDeskingMode = (toFIMode: boolean) => (dispatch: any, getState: any) => {
    const newMode = toFIMode ? DealMode.fiMode : DealMode.deskingMode;
    const state = getState();

    dispatch(changeDealMode(newMode));

    if (toFIMode) {
        const currentOfferType = offerReduxSelectors.getCurrentOfferType(state);
        const currentEndpoint = offerReduxSelectors.getCalculationEndpointByOfferType(state, currentOfferType);
        if (currentEndpoint !== CALC_ENDPOINTS.userProgramQuotes) {
            dispatch(setProgramFallbackOverrides());
            dispatch(updateCurrentCalculationEndpoint(CALC_ENDPOINTS.userProgramQuotes, currentOfferType, { withPayment: true }));
        }
    }
};
